<template>
    <v-layout align-center justify-center column>
        <h1>Account</h1>
        <v-btn>Reset Account</v-btn>
    </v-layout>
</template>

<script>
    export default {
        data: function() {

        },
        methods: {
            resetAccount() {
                
            }
        }
    }
</script>

<style scoped>
</style>